var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#555770",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4792_9928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6169 10.9301L8.76083 7.95969C9.49516 7.08675 9.89751 5.98841 9.89751 4.845C9.89751 2.17351 7.724 0 5.05252 0C2.38103 0 0.20752 2.17351 0.20752 4.845C0.20752 7.51648 2.38103 9.68999 5.05252 9.68999C6.05543 9.68999 7.01116 9.38749 7.82828 8.81326L10.706 11.8062C10.8263 11.9311 10.9881 12 11.1614 12C11.3255 12 11.4812 11.9374 11.5994 11.8237C11.8505 11.5821 11.8585 11.1814 11.6169 10.9301ZM5.05252 1.26391C7.02717 1.26391 8.6336 2.87034 8.6336 4.845C8.6336 6.81965 7.02717 8.42608 5.05252 8.42608C3.07786 8.42608 1.47143 6.81965 1.47143 4.845C1.47143 2.87034 3.07786 1.26391 5.05252 1.26391Z",
    fill: "#555770"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4792_9928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#555770"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9ad4db9503a6b71390b050f821462253.svg";
export { ForwardRef as ReactComponent };